import { createReducer } from '@reduxjs/toolkit';

import { Nullable, RequestState } from 'modules/types/common';
import { switchAccountSuccess } from 'store/account/actions';
import { normalizedAppointments } from 'store/booking/mappers';

import * as actions from './actions';
import { BookedAppointment } from '../types';

/**
 * NOTE: We do not currently use this reducer
 * but I wanted to keep it since this section of the app is evolving
 */

export type PastAppointmentsState = Readonly<{
  isFetching: boolean;
  error: Nullable<Error>;
  data: BookedAppointment[];
  requestState: RequestState;
}>;

export const pastAppointmentsInitialState: PastAppointmentsState = {
  isFetching: false,
  error: null,
  data: [],
  requestState: RequestState.INITIALIZED
};

export const pastAppointmentsReducer = createReducer(pastAppointmentsInitialState, {
  [actions.GET_PAST_APPOINTMENTS]: state => {
    state.isFetching = true;
    state.error = null;
    state.requestState = RequestState.REQUESTING;
  },
  [actions.GET_PAST_APPOINTMENTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
    state.requestState = RequestState.ERROR;
  },
  [actions.GET_PAST_APPOINTMENTS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = normalizedAppointments(action.payload.data);
    state.requestState = RequestState.SUCCESS;
  },
  [switchAccountSuccess.type]: () => pastAppointmentsInitialState
});

export default pastAppointmentsReducer;
